export const GET_CUSTOMERS_REQUEST = 'GET_CUSTOMERS_REQUEST'
export function getCustomersRequest() {
    return {
        type: GET_CUSTOMERS_REQUEST
    }
}

export const GET_CUSTOMERS_SUCCESS = 'GET_CUSTOMERS_SUCCESS'
export function getCustomersSuccess(customers) {
    return {
        type: GET_CUSTOMERS_SUCCESS,
        customers
    }
}

export const GET_CUSTOMERS_ERROR = 'GET_CUSTOMERS_ERROR'
export function getCustomersError() {
    return {
        type: GET_CUSTOMERS_ERROR
    }
}

export const GET_CUSTOMER_REQUEST = 'GET_CUSTOMER_REQUEST'
export function getCustomerRequest(customerId) {
    return {
        type: GET_CUSTOMER_REQUEST,
        customerId
    }
}

export const GET_CUSTOMER_SUCCESS = 'GET_CUSTOMER_SUCCESS'
export function getCustomerSuccess(customer) {
    return {
        type: GET_CUSTOMER_SUCCESS,
        customer
    }
}

export const GET_CUSTOMER_ERROR = 'GET_CUSTOMER_ERROR'
export function getCustomerError() {
    return {
        type: GET_CUSTOMER_ERROR
    }
}

export const UPDATE_CUSTOMER_REQUEST = 'UPDATE_CUSTOMER_REQUEST'
export function updateCustomerRequest(customerId, body) {
    return {
        type: UPDATE_CUSTOMER_REQUEST,
        customerId,
        body
    }
}

export const UPDATE_CUSTOMER_SUCCESS = 'UPDATE_CUSTOMER_SUCCESS'
export function updateCustomerSuccess() {
    return {
        type: UPDATE_CUSTOMER_SUCCESS
    }
}

export const UPDATE_CUSTOMER_ERROR = 'UPDATE_CUSTOMER_ERROR'
export function updateCustomerError() {
    return {
        type: UPDATE_CUSTOMER_ERROR
    }
}

export const GET_SOFTWARE_PLANS_REQUEST = 'GET_SOFTWARE_PLANS_REQUEST'
export function getSoftwarePlansRequest() {
    return {
        type: GET_SOFTWARE_PLANS_REQUEST
    }
}

export const GET_SOFTWARE_PLANS_SUCCESS = 'GET_SOFTWARE_PLANS_SUCCESS'
export function getSoftwarePlansSuccess(softwarePlans) {
    return {
        type: GET_SOFTWARE_PLANS_SUCCESS,
        softwarePlans
    }
}

export const GET_SOFTWARE_PLANS_ERROR = 'GET_SOFTWARE_PLANS_ERROR'
export function getSoftwarePlansError() {
    return {
        type: GET_SOFTWARE_PLANS_ERROR
    }
}

export const SET_CUSTOMERS = 'SET_CUSTOMERS'
export function setCustomers(customers) {
    return {
        type: SET_CUSTOMERS,
        customers
    }
}

export const IMPERSONATE_USER = 'IMPERSONATE_USER'
export function impersonateUser(userIdToImpersonate) {
    return {
        type: IMPERSONATE_USER,
        payload: { userIdToImpersonate }
    }
}
